import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import { FaSearch, FaRegTimesCircle, FaDownload, FaRegEye, FaVoteYea, FaRegFilePdf, FaRegFileExcel } from "react-icons/fa";
import { useHistory, useParams } from "react-router-dom";
import { HiRefresh } from "react-icons/hi";
import "../../css/makeTable.css";
import { getData } from "../../store/utils";
import Loader from "../../component/Loader";
import OrderListTable from "./OrderListTable";
import Modal from "react-modal";
import Swal from "sweetalert2";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useAsyncDebounce,
  usePagination,
  useSortBy,
} from "react-table";
import { formatDateTimeString, formatNumberWithCommasAndDecimals } from "../../component/common";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Mobile from "./component/Mobile";
import { LuLogOut } from "react-icons/lu";
import { useDebounce } from 'use-debounce';
import InventoryComponent from "./component/InventoryComponent";


function WarehouseOrderList() {
  const userRole = localStorage.getItem("USER_ROLE");
  const searchParams = new URLSearchParams(window.location.search);
  const newStatusId = searchParams.get("statusId"); // This will now return the correct value


  const [orderListData, setOrderListData] = useState([]);
  const [searchBoxValue, setSearchBoxValue] = useState("");
  const [isLoadingOn, setIsLoadingOn] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState("");
  const [orderBy, setOrderBy] = useState("desc");
  const [errorMessage, setErrorMessage] = useState("");
  const [orderQuotationOpen, setOrderQuotationOpen] = React.useState(false);
  const [orderQuotationData, setOrderQuotationData] = useState();
  const [modalIsOpen, setIsOpen] = React.useState(false);

  const [activeTab, setActiveTab] = useState('orders');
  const [selectedStatuses, setSelectedStatuses] = useState([newStatusId]);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageNew, setPagenew] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  


  // new state mobile
  
  

  const { statusId } = useParams();
  useEffect(() => {
    
  }, [statusId]);


  const [debouncedSearch] = useDebounce(searchTerm, 500);

  const history = useHistory();



  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      overflow: "none",
      padding: "0px",
    },
  };




  const handleInputChange = (e) => {
    setSearchBoxValue(e.target.value);
  };

  const resetFilters = () => {
    setSearchBoxValue("");
    setPageIndex(0);
    setSortBy("");
    setOrderBy("desc");
  };

  const closeModal = () => {
    setIsOpen(false);
    setOrderQuotationOpen(false);
   
  };

  const fetchData = useCallback(async (
    pageNew = 0,
    pageSize = 12,
    sortBy = "",
    orderBy = "",
    shipmentStatuses = [],
    searchTerm = "",
    append = false
  ) => {
    setIsLoadingOn(true);
    const pageNumber = pageNew + 1;
    const statusParam = shipmentStatuses.filter(Boolean).join(",");
    const apiUrl = `warehouse/getOrders?pageSize=${pageSize+2}&page=${pageNumber}&shipmentStatus=${statusParam}&search=${searchTerm}`;
  
    try {
      const tempData = await getData(apiUrl);
      const records = tempData?.data || [];
  
      if (tempData.status) {
        if (append) {
          // ⛔ Do not reset to [] if appending
          if (records.length > 0) {
            setOrderListData(prev => [...prev, ...records]);
          }
          // If no records, we just stop pagination, no state change
        } else {
          // Reset the full list if not appending
          setOrderListData(records);
        }
  
        // Pagination state
        const totalPages = tempData.pagination?.totalPagesCount || 1;
        const total = tempData.pagination?.totalRecords || 0;
  
        setPageCount(totalPages);
        setTotalRecords(total);
        setHasMore(pageNumber < totalPages);
        setErrorMessage(records.length === 0 ? "No Data Found" : "");
      } else {
        // On failed API response
        if (!append) setOrderListData([]);
        setHasMore(false);
        setErrorMessage("No Data Found");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      if (!append) setOrderListData([]);
      setHasMore(false);
      setErrorMessage("Error fetching data");
    } finally {
      setTimeout(() => {
        setIsLoadingOn(false);
      }, 500); // optional: reduce delay to 500ms for better UX
    }
  }, []);
  

  useEffect(() => {
    setPagenew(0); // Reset page
    fetchData(0, 10, "", "", selectedStatuses, debouncedSearch, false);
  }, [debouncedSearch, selectedStatuses]);

  const onLoadMore = () => {




    if (hasMore && !isLoadingOn) {
    const nextPage = pageNew + 1;
    console.log("Calling API for page:", nextPage);
    fetchData(nextPage, 10, "", "", selectedStatuses, debouncedSearch, true);
    setPagenew(nextPage); // <-- Update the state here!
    }

  };
  

  // Handle search term change
  const handleSearchChange = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  const handleLogout = () => {
    // setIsAuthenticated("");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("jwtRefreshToken");
    localStorage.removeItem("USER_ROLE");
    localStorage.removeItem("USER_DATA");
    window.location.href = "/login";
  };

  const handleSort = (column) => {
    let newOrderBy = "asc";
    if (sortBy === column.id) {
      newOrderBy = orderBy === "asc" ? "desc" : "asc";
    }
    setSortBy(column.id);
    setOrderBy(newOrderBy);
  };

  // useEffect(() => {
  //   fetchData(pageIndex, pageSize, sortBy, orderBy);
  // }, [pageIndex, pageSize, sortBy, orderBy]);


  const orderQuotationColumns = useMemo(() => [
    {
      Header: "Sr. No.",
      accessor: (row, i) => i + 1,
      Cell: ({ cell }) => (
        <span style={{ fontWeight: "600", fontSize: "0.875rem" }}>
          {cell.row.index + 1}.
        </span>
      ),
    },
    {
      Header: "Order Id",
      accessor: "orderId",
    },
    {
      Header: "Brand",
      accessor: "brand",
      Footer: <div className="tblFooterColor">Total Amount</div>,
    },
    {
      Header: "Item",
      accessor: "item",
    },
    {
      Header: "Color",
      accessor: "color",
    },
    {
      Header: "Quantity",
      accessor: "quantity",
    },
    {
      Header: "Rate",
      accessor: "rate",
      Cell: ({ cell }) => {
        const rate = cell.row.original.rate;
        return (
          <>
            <span>{rate && rate.toFixed(2)}</span>
          </>
        );
      },
    },

    {
      Header: "Gst Applicable",
      accessor: "isGstApplicable",
      Cell: ({ cell }) => {
        const GstApplicable = cell.row.original.isGstApplicable;
        return (
          <>
            <span>{GstApplicable == 1 ? "Yes" : "No"}</span>
          </>
        );
      },
    },
    {
      Header: "Total Amount",
      accessor: "amountWithGST",

      Cell: ({ value }) => {
        const numericValue = Number(value);
        if (!isNaN(numericValue)) {
          return formatNumberWithCommasAndDecimals(numericValue);
        } else {
          return value || "-";
        }
      },
      Footer: (info) => {
        const totalAmount = info.rows.reduce(
          (sum, row) => sum + row.values.amountWithGST,
          0
        );

        return (
          <div className="tblFooterColor">
            {totalAmount && formatNumberWithCommasAndDecimals(totalAmount)}
          </div>
        );
      },
    },
    {
      Header: "Created Date",
      accessor: "OrderDetailDateTime",
      Cell: ({ cell }) => {
        return (
          <>
            <span>
              {cell.row.original.OrderDetailDateTime &&
                formatDateTimeString(cell.row.original.OrderDetailDateTime)}
            </span>
          </>
        );
      },
    },
  ]);

  const columns = useMemo(
    () => [
      {
        Header: "Order Code",
        accessor: "orderId",
        Cell: ({ cell }) => {
          return (
            <>
              <div className="loanIdDownloadBtnDiv">
                <button
                  className="btn btn-sm someprobtn view-log-detail loanTblDownloadLoanIdBtn"
                  title="View details"
                  value={cell.row.original.orderId}
                  onClick={() => {
                    //   if (userRole === "Admin" || userRole === "Operation") {
                    displayMerchantInfo(cell.row.original);
                    //   }
                  }}
                >
                  <span style={{ fontWeight: "600" }}>
                    {cell.row.original.orderId}
                  </span>
                </button>
              </div>
            </>
          );
        },
        filter: "fuzzyText",
        disableSortBy: true,
        disableFilters: false,
      },
      { Header: "Distributor Name", accessor: "distributorName" },
      { Header: "Shop Name", accessor: "shopName" },
      { Header: "Mobile Number", accessor: "mobileNumber" },

    ],
    []
  );

  const displayMerchantInfo = (user) => {
    sessionStorage.setItem("orderUser", JSON.stringify(user));
    // history.push(`/WarehouseOrderDetail`);
  };


  


  

  


  return (
    <div>
      <h4 className="d-none d-md-block" style={{ marginBottom: 10 }}>Orders List</h4>
      <div className="customHeaderTable warehousemobileView">
        <div className="d-block d-md-none">
          <ul className="nav nav-tabs align-items-center justify-content-center">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'orders' ? 'active' : ''}`}
                onClick={() => setActiveTab('orders')}
              >
                Orders
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'inventory' ? 'active' : ''}`}
                onClick={() => setActiveTab('inventory')}
              >
                Inventory
              </button>
            </li>
            <li className="ms-auto">
              <div
                // component={<Link to="/login" />}
                // style={isActive("/login") ? activeStyle : {}}

                onClick={handleLogout}
              >
                <LuLogOut style={{ fontSize: 20 }} />
              </div>
            </li>
          </ul>
        </div>
        <div className="d-none d-md-block">
          <div className="row alignmentTable">
            <div className="col-12 col-md-2 pd0">
              <input
                type="text"
                className="searchInputField"
                onChange={handleInputChange}
                placeholder="Enter Search Text"
                value={searchBoxValue}
              />
            </div>
            <div className="col-md-2 text-center">
              <button className="searchTableData" onClick={() => fetchData(pageIndex, pageSize, sortBy, orderBy)}>
                <FaSearch /> Search
              </button>
            </div>
            <div className="col-md-2 text-center" onClick={resetFilters}>
              <button className="resetTableData">
                <HiRefresh /> Reset
              </button>
            </div>
          </div>
        </div>

        <div className="tab-content border-top-0 mt-3 d-block d-md-none">
          {activeTab === 'orders' && <div className="tab-pane active">
            {/* <Mobile orderListData={orderListData} /> */}
            <Mobile
              orderListData={orderListData}
              selectedStatuses={selectedStatuses}
              onSearchChange={handleSearchChange}
              onStatusFilterChange={setSelectedStatuses}
              isLoading={isLoadingOn}
              errorMessage={errorMessage}
              loadMore={onLoadMore} // 👈 pass here
              hasMore={hasMore}   // 👈 and this
              onItemClick={displayMerchantInfo} // ✅ pass this new prop
              statusId={newStatusId}
            />
          </div>}
          {activeTab === 'inventory' && <div className="tab-pane active">
           <InventoryComponent />
          </div>}
        </div>
      </div>

      <div className="orderListDataFooter d-none d-md-block">
        <OrderListTable
          data={orderListData}
          userRole={userRole}
          columns={columns}
          pageCount={pageCount}
          pageIndex={pageIndex}
          pageSize={pageSize}
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
          totalRecords={totalRecords}
          handleSort={handleSort}
          sortBy={sortBy}
          orderBy={orderBy}
          handleGotoPage={setPageIndex}
          errorMessage={errorMessage}
        />
      </div>
      <Modal
        isOpen={orderQuotationOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        {isLoadingOn ? <Loader /> : null}
        <button className="modalCloseBtn" onClick={closeModal}>
          <FaRegTimesCircle />
        </button>
        <h4 className="pleaseSelectStatus">Order Quotation List</h4>
        <div className="modalUserStatusQuatation">
          {orderQuotationData && (
            <Table columns={orderQuotationColumns} data={orderQuotationData} />
          )}
        </div>
      </Modal>
    </div>
  );

  // }

}

export default WarehouseOrderList;



// Define a default UI for filtering
function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}) {


  return (
    <div>
      <input
        value={filterValue || ""}
        onChange={(e) => {
          setFilter(e.target.value.toString().toLowerCase() || undefined); // Set undefined to remove the filter entirely
        }}
        // placeholder={`Search ${count} records...`}
        className="searchFilter"
      />
      <i className="flaticon-search searchIcon"></i>
    </div>
  );
}




function fuzzyTextFilterFn(rows, id, filterValue) {
  // return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = (val) => !val;

// Our table compone

// Define a custom filter filter function!
function filterGreaterThan(rows, id, filterValue) {
  return rows.filter((row) => {
    const rowValue = row.values[id];
    return rowValue >= filterValue;
  });
}

function Table({ columns, data }) {
  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue)
              .toLowerCase()
              .startsWith(String(filterValue).toLowerCase())
            : true;
        });
      },
    }),
    []
  );

  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter,
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    //state,
    visibleColumns,
    preGlobalFilteredRows,
    setGlobalFilter,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn, // Be sure to pass the defaultColumn option
      filterTypes,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useFilters, // useFilters!
    useGlobalFilter, // useGlobalFilter!
    useSortBy, //sort data
    usePagination //use pagination
  );

  // We don't want to render all of the rows for this example, so cap
  // it for this use case
  //const firstPageRows = rows.slice(0, 10);

  return (
    <>
      <div>
        <table {...getTableProps()} className="dashboardTable">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr

                {...headerGroup.getHeaderGroupProps()}
                className="tableHeader"
              >
                {headerGroup.headers.map((column) => (
                  <th  {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    {/* Add a sort direction indicator */}
                    <span>
                      {column.isSorted ? (column.isSortedDesc ? "↓" : "↑") : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
            {/* <tr>
                    <th
                      colSpan={visibleColumns.length}
                      style={{
                        textAlign: 'left',
                      }}
                    >
                    </th>
                  </tr> */}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="tableTd">
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
          <tfoot className="orderTableFooter">
            {footerGroups.map((group) => (
              <tr {...group.getFooterGroupProps()}>
                {group.headers.map((column) => (
                  <td {...column.getFooterProps()}>
                    {column.render("Footer")}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot>
        </table>
        <div className="row m-0">
          <div className="pagination col-lg-12">
            <div className="col-lg-2">
              <button
                className="defaultPaginationButton"
                onClick={() => gotoPage(0)}
                disabled={!canPreviousPage}
              >
                {"<<"}
              </button>{" "}
              <button
                className="defaultPaginationButton"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
              >
                {"<"}
              </button>{" "}
              <button
                className="defaultPaginationButton"
                onClick={() => nextPage()}
                disabled={!canNextPage}
              >
                {">"}
              </button>{" "}
              <button
                className="defaultPaginationButton"
                onClick={() => gotoPage(pageCount - 1)}
                disabled={!canNextPage}
              >
                {">>"}
              </button>{" "}
            </div>
            <div className="col-lg-2">
              <span>
                Total Records <strong>{rows.length}</strong>{" "}
              </span>
            </div>
            <div className="col-lg-2">
              <span>
                Page{" "}
                <strong>
                  {pageIndex + 1} of {pageOptions.length}
                </strong>{" "}
              </span>
            </div>
            <div className="col-lg-3">
              <span>
                Go to page{" "}
                <input
                  type="number"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const page = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(page);
                  }}
                  className="gotoPage"
                />
              </span>{" "}
            </div>
            <div className="col-lg-3">
              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                }}
                className="selectDisplayNoOfRecords"
              >
                {[10, 20, 30, 50].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <br />
      </div>
    </>
  );
}
filterGreaterThan.autoRemove = (val) => typeof val !== "number";